// extracted by mini-css-extract-plugin
export default {"root":"HelperText_root__5MpGY","absolute":"HelperText_absolute__USr5S","static":"HelperText_static__lxggt","left":"HelperText_left__BW+L-","right":"HelperText_right__qQu0c"};